import { Loader } from '../Loader/Loader'

import styles from './PreparingAppLoader.module.css'

export const PreparingAppLoader = () => {
	return (
		<div className={styles.container}>
			<Loader className={styles.loader} />
			<div className={styles.message}>
				Qodana is getting ready...
				<br />
				Give us a few seconds to load the application.
			</div>
		</div>
	)
}
